// next
import { Container, Link, Stack, Typography } from '@mui/material';
// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { imageProps } from '@utils/image';
import NextImage from "next/image";
import NextLink from 'next/link';
import { ArticleProps } from 'src/@types/article';
// routes
import Routes from '../../routes';
// utils
import { fDate } from '../../utils/formatTime';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(10, 0),
  backgroundColor: theme.palette.background.neutral,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(10, 0),
  },
}));

const DotStyle = styled('span')(({ theme }) => ({
  width: 4,
  height: 4,
  borderRadius: '50%',
  backgroundColor: 'currentColor',
  margin: theme.spacing(0, 1),
}));

// ----------------------------------------------------------------------

type Props = {
  article: ArticleProps;
};

export default function BlogFeaturedPosts({ article }: Props) {
  const { title, header, description, date, slug } = article;

  return (
    <RootStyle>
      <Container>
        {/* <Typography variant="h2" sx={{ mb: 10 }}>Aktuelt</Typography> */}
        <Stack direction={{ xs: 'column', md: 'row' }}>
          <NextLink passHref as={Routes.post(slug.current)} href={Routes.post('[slug]')}>
            <Box component="a"
              position="relative"
              sx={{ overflow: 'hidden', flexGrow: 1, height: 400, borderRadius: 2 }}
            >
              <NextImage {...imageProps(header)} layout="fill" objectFit="cover" alt={title} />
            </Box>
          </NextLink>

          <Stack
            spacing={1}
            sx={{
              mx: 'auto',
              pl: { md: 8 },
              py: { xs: 3, md: 5 },
              maxWidth: { md: 408 },
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              sx={{ typography: 'caption', color: 'text.disabled' }}
            >
              {fDate(date)}
              <DotStyle />
            </Stack>

            <NextLink passHref as={Routes.post(slug.current)} href={Routes.post('[slug]')}>
              <Link color="inherit" variant="h3">
                {title}
              </Link>
            </NextLink>

            <Typography sx={{ color: 'text.secondary', flexGrow: 1 }}>{description}</Typography>
          </Stack>
        </Stack>
      </Container>
    </RootStyle>
  );
}
